"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATISTICS_MENUT_LIST = exports.BACK_MENUT_LIST = exports.ACADEMY_STATISTICS_MENU_LIST = exports.ACADEMY_MENU_LIST = exports.CLASS_MENUT_LIST = exports.SERVICE_MENUT_LIST = exports.MENU_LIST = exports.DEFAULT_MENU = void 0;
exports.DEFAULT_MENU = 'classManagement';
// 'serviceManagment',
exports.MENU_LIST = ['classManagement', 'academyManagement', 'backOffice', 'statistics'];
exports.SERVICE_MENUT_LIST = ['company', 'user', 'version'];
exports.CLASS_MENUT_LIST = ['classManagement', 'banner'];
exports.ACADEMY_MENU_LIST = ['academyManagement', 'academyClassManagement'];
exports.ACADEMY_STATISTICS_MENU_LIST = ['academyStatistics', 'academyClassStatistics'];
exports.BACK_MENUT_LIST = ['assignment', 'test'];
exports.STATISTICS_MENUT_LIST = ['userStatistics', 'concurrentStatistics'];
